import { z } from "zod";
import {
  VALIDATION_MESSAGES,
  REGEX_PATTERNS,
  VALIDATION_LIMITS,
} from "../constants";
import { requiredString } from "../utils/validationUtils";

// Define validation schema for vehicle data
export const vehicleDataSchema = z.object({
  ulid: z.string().optional(),
  license_plate: z.string().optional().describe("Nomor polisi kendaraan"),
  vehicle_type_ulid: requiredString(VALIDATION_MESSAGES.REQUIRED.VEHICLE_TYPE),
  kir_number: z
    .string()
    .max(
      VALIDATION_LIMITS.KIR_NUMBER_MAX_LENGTH,
      VALIDATION_MESSAGES.LENGTH.KIR_NUMBER_MAX
    )
    .optional()
    .describe("Nomor KIR kendaraan"),
  kir_expired_date: z.any().optional().describe("Masa berlaku uji berkala"),
  status: z.enum(["active", "inactive"]).describe("Status"),
  vehicle_type: z
    .object({
      ulid: z.string(),
      name: z.string(),
      cubic_capacity: z.number(),
    })
    .optional()
    .describe("Detail tipe kendaraan"),
  cubication: z.string().optional().describe("Kapasitas kubikasi kendaraan"),
  created_by_ulid: z.string().optional(),
  updated_by_ulid: z.string().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
  license_plate_prefix: z
    .string()
    .regex(
      REGEX_PATTERNS.UPPERCASE_LETTERS,
      VALIDATION_MESSAGES.FORMAT.LICENSE_PLATE_PREFIX_CAPS
    )
    .min(
      VALIDATION_LIMITS.LICENSE_PLATE_PREFIX_MIN_LENGTH,
      VALIDATION_MESSAGES.LENGTH.LICENSE_PLATE_PREFIX_MIN
    )
    .max(
      VALIDATION_LIMITS.LICENSE_PLATE_PREFIX_MAX_LENGTH,
      VALIDATION_MESSAGES.LENGTH.LICENSE_PLATE_PREFIX_MAX
    )
    .nonempty(VALIDATION_MESSAGES.REQUIRED.LICENSE_PLATE_PREFIX),
  license_plate_number: z
    .string()
    .regex(
      REGEX_PATTERNS.NUMERIC_ONLY,
      VALIDATION_MESSAGES.FORMAT.LICENSE_PLATE_NUMBER_NUMERIC
    )
    .min(
      VALIDATION_LIMITS.LICENSE_PLATE_NUMBER_MIN_LENGTH,
      VALIDATION_MESSAGES.LENGTH.LICENSE_PLATE_NUMBER_MIN
    )
    .max(
      VALIDATION_LIMITS.LICENSE_PLATE_NUMBER_MAX_LENGTH,
      VALIDATION_MESSAGES.LENGTH.LICENSE_PLATE_NUMBER_MAX
    )
    .nonempty(VALIDATION_MESSAGES.REQUIRED.LICENSE_PLATE_NUMBER),
  license_plate_suffix: z
    .string()
    .regex(
      REGEX_PATTERNS.UPPERCASE_LETTERS,
      VALIDATION_MESSAGES.FORMAT.LICENSE_PLATE_SUFFIX_CAPS
    )
    .min(
      VALIDATION_LIMITS.LICENSE_PLATE_SUFFIX_MIN_LENGTH,
      VALIDATION_MESSAGES.LENGTH.LICENSE_PLATE_SUFFIX_MIN
    )
    .max(
      VALIDATION_LIMITS.LICENSE_PLATE_SUFFIX_MAX_LENGTH,
      VALIDATION_MESSAGES.LENGTH.LICENSE_PLATE_SUFFIX_MAX
    )
    .nonempty(VALIDATION_MESSAGES.REQUIRED.LICENSE_PLATE_SUFFIX),
});

// Partial schema for update vehicle data
export const vehicleSchema = vehicleDataSchema.omit({
  vehicle_type: true,
  created_by_ulid: true,
  updated_by_ulid: true,
  created_at: true,
  updated_at: true,
});

export const vehicleCsvSchema = vehicleSchema.partial().omit({
  cubication: true,
  license_plate_number: true,
  ulid: true,
  license_plate_prefix: true,
  license_plate_suffix: true,
});

